module.exports = __webpack_public_path__ + "static/media/4-7.59dda244.mp3";